{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {},
      "geometry": {
        "coordinates": [
          [
            [
              114.24049472637273,
              22.54834845949567
            ],
            [
              114.16572017600089,
              22.559438766434795
            ],
            [
              114.03618778477767,
              22.506475755520114
            ],
            [
              113.81849321677117,
              22.369453015394114
            ],
            [
              113.75705793991006,
              22.129648079446667
            ],
            [
              113.86790854815916,
              22.06901397824862
            ],
            [
              114.32333092662424,
              22.092528252790714
            ],
            [
              114.4301748863839,
              22.48796708119191
            ],
            [
              114.33267808825076,
              22.553351050937266
            ],
            [
              114.24049472637273,
              22.54834845949567
            ]
          ]
        ],
        "type": "Polygon"
      }
    }
  ]
}